// src/contexts/OnboardingContext.js
import React, { createContext, useContext, useState } from "react";

const OnboardingContext = createContext();
const STORAGE_KEY = "mindsherpa_onboarding_data";

export const OnboardingProvider = ({ children }) => {
  const [onboardingData, setOnboardingData] = useState(() => {
    try {
      const saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved) {
        return JSON.parse(saved);
      }
    } catch (e) {
      console.warn("Failed to load onboarding data from sessionStorage", e);
    }
    return {
      email: "",
      name: "",
      age: "",
      gender: "",
      focus: "",
    };
  });

  const updateOnboardingData = (updater) => {
    setOnboardingData((prev) => {
      const next = typeof updater === "function" ? updater(prev) : { ...prev, ...updater };
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch (e) {}
      return next;
    });
  };

  return (
    <OnboardingContext.Provider value={{ onboardingData, setOnboardingData: updateOnboardingData }}>
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => useContext(OnboardingContext);

